import React, { useEffect, useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import "./_footer.scss";
import { HashLink as Link } from "react-router-hash-link";
import Title from "../Title/Title";
import OutsideClickHandler from "react-outside-click-handler";

const Footer = () => {
  const windowSize = useWindowSize();

  const [metaverse, setMetaverse] = useState(false);

  const socials = [
    {
      name: "Twitter",
      link: "https://twitter.com/dypius",
    },
    {
      name: "Telegram",
      link: "https://t.me/dypius",
    },
    {
      name: "Announcements",
      link: "https://t.me/dypannouncements",
    },
    // {
    //   name: "Discord",
    //   link: "https://discord.gg/worldofdypians",
    // },
    {
      name: "Instagram",
      link: "https://www.instagram.com/dyp.eth",
    },
    {
      name: "Medium",
      link: "https://medium.com/@dypius",
    },
    // {
    //   name: "Youtube",
    //   link: "https://www.youtube.com/@Dypius",
    // },
    {
      name: "Linkedin",
      link: "https://www.linkedin.com/company/dypius-ecosystem",
    },
    {
      name: "Github",
      link: "https://github.com/dypfinance",
    },
    {
      name: "Email",
      link: "mailto:business@dypius.com",
    },
  ];

  const about = [
    {
      title: "Our partners",
      link: "/about#our-partners",
    },
    {
      title: "Brand",
      link: "/about#brand",
    },
    {
      title: "Roadmap",
      link: "/about#roadmap",
    },
    {
      title: "Security",
      link: "/about#security",
    },
   

    {
      title: "Contact us",
      link: "/about#contactus",
    },
  ];

  const products = [
    {
      title: "Earn",
      link: "https://app.dypius.com/earn",
    },
    {
      title: "DYP Tools",
      link: "https://app.dypius.com",
    },
    {
      title: "Governance",
      link: "/governance",
    },
    {
      title: "Bridge",
      link: "https://app.dypius.com/bridge",
    },
    // {
    //   title: "Buy DYP",
    //   link: "/buydyp",
    // },
  
    {
      title: "Metaverse",
      link: "https://www.worldofdypians.com/",
    },
  ];

  const announcements = [
    {
      title: "Latest announcements",
      link: "/news",
      props: "announcements",
    },

    {
      title: "Latest events",
      link: "/news",
      props: "events",
    },
    {
      title: "Press",
      link: "/news#press",
    },
  ];

  const year = new Date();

  const [indicators, setIndicators] = useState({
    about: false,
    products: false,
    announcements: false,
    learn: false,
  });

  const openAccordion = (type) => {
    if (type === 1) {
      setIndicators({
        about: !indicators.about,
        products: false,
        announcements: false,
        learn: false,
      });
    }
    if (type === 2) {
      setIndicators({
        about: false,
        products: !indicators.products,
        announcements: false,
        learn: false,
      });
    }
    if (type === 3) {
      setIndicators({
        about: false,
        products: false,
        announcements: !indicators.announcements,
        learn: false,
      });
    }
    if (type === 4) {
      setIndicators({
        about: false,
        products: false,
        announcements: false,
        learn: !indicators.learn,
      });
    }
  };

  const html = document.querySelector("html");
  const metaverseModalIndicator = document.querySelector(
    ".metaverse-modal-wrapper"
  );

  useEffect(() => {
    if (metaverse === true) {
      html.classList.add("hidescroll");
      metaverseModalIndicator.style.pointerEvents = "auto";
    } else {
      // Enable scroll
      html.classList.remove("hidescroll");
    }
  }, []);

  return (
    <>
      <div className="container-fluid p-0 footer">
        <div className="socials container-fluid">
          {/* <div className="container-lg socials-container d-grid align-items-center">
            {socials.map((social, index) => (
              <div key={index} className="col-4 col-lg">
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                  href={social.link}
                >
                  <div
                    className="d-flex flex-row justify-content-start justify-content-lg-center align-items-center"
                    style={{ gap: "5px" }}
                  >
                    <img
                      width={25}
                      height={25}
                      src={`https://cdn.worldofdypians.com/dypius/${social.name.toLowerCase()}Footer.svg`}
                      alt=""
                    />
                    <p className="mb-0">{social.name}</p>
                  </div>
                </a>
              </div>
            ))}
          </div> */}
        </div>
        <div className="container-fluid px-3 px-lg-5 py-0 footer-links justify-content-center">
          <div className="container-lg d-flex mt-0 mt-lg-4 footer-blocks w-100 position-relative align-items-baseline justify-content-between py-4 py-lg-1">
            {windowSize.width < 821 ? (
              <div className="accordion w-100" id="accordionFooter">
                <div className="col-12 col-lg-3 text-white d-flex flex-column gap-3 px-0 py-3">
                  <div
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div
                      className="d-flex align-items-center justify-content-between"
                      onClick={() => openAccordion(1)}
                    >
                      <h4 className="fw-normal">About Us</h4>
                      <img
                        className={
                          indicators.about ? `indicator turn` : "indicator"
                        }
                        src={`https://cdn.worldofdypians.com/dypius/accordionIndicator2.svg`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionFooter"
                  >
                    <div className="d-flex flex-column gap-3">
                      {about.map((item, index) => (
                        <Link
                          key={index}
                          to={item.link}
                          className="text-white text-decoration-none footer-type-link"
                        >
                          <h5>{item.title}</h5>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
                <hr />

                <div className="col-12 col-lg-3 text-white d-flex flex-column gap-3 px-0 py-3">
                  <div
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    <div
                      className="d-flex align-items-center justify-content-between"
                      onClick={() => openAccordion(2)}
                    >
                      <h4 className="fw-normal">Solutions</h4>
                      <img
                        className={
                          indicators.products ? `indicator turn` : "indicator"
                        }
                        src={`https://cdn.worldofdypians.com/dypius/accordionIndicator2.svg`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionFooter"
                  >
                    <div className="row">
                      <div className="col-12 d-flex flex-column gap-3">
                        {products.slice(0, 2).map((item, index) => (
                          <a
                            key={index}
                            href={item.link}
                            className="text-white text-decoration-none footer-type-link"
                          >
                            <h5>{item.title}</h5>
                          </a>
                        ))}

                        {products.slice(2, 3).map((item, index) => (
                          <Link
                            key={index}
                            to={item.link}
                            className="text-white text-decoration-none footer-type-link"
                          >
                            <h5>{item.title}</h5>
                          </Link>
                        ))}
                        {products.slice(3, 4).map((item, index) => (
                          <a
                            key={index}
                            href={item.link}
                            className="text-white text-decoration-none footer-type-link"
                          >
                            <h5>{item.title}</h5>
                          </a>
                        ))}

                        {products.slice(4, 5).map((item, index) => (
                          <Link
                            key={index}
                            to={item.link}
                            className="text-white text-decoration-none footer-type-link"
                          >
                            <h5>{item.title}</h5>
                          </Link>
                        ))}
                        {/* {products
                          .slice(products.length - 1, products.length)
                          .map((item, index) => (
                            <a
                              className="text-white text-decoration-none footer-type-link"
                              href={item.link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <h5>{item.title}</h5>
                            </a>
                          ))} */}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
             
                <hr />
                <div className="col-12 col-lg-3 text-white d-flex flex-column gap-3 px-0 py-3">
                  <div
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                  >
                    <div
                      className="d-flex align-items-center justify-content-between"
                      onClick={() => openAccordion(3)}
                    >
                      <h4 className="fw-normal">Announcements</h4>
                      <img
                        className={
                          indicators.announcements
                            ? `indicator turn`
                            : "indicator "
                        }
                        src={`https://cdn.worldofdypians.com/dypius/accordionIndicator2.svg`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionFooter"
                  >
                    <div className="d-flex flex-column gap-3">
                      {announcements.map((item, index) => (
                        <Link
                          key={index}
                          to={item.link}
                          className="text-white text-decoration-none footer-type-link"
                          state={{ newsType: item.props }}
                        >
                          <h5>{item.title}</h5>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
                <hr />
                <div className="d-flex flex-column gap-1 mt-3">
                  <Link
                    to={"/terms-of-service"}
                    className="text-white text-decoration-none footer-type-link"
                  >
                    <h5>Terms of Service</h5>
                  </Link>
               
                </div>
              </div>
            ) : (
              <>
                <Link to="/">
                  <img src={"https://cdn.worldofdypians.com/dypius/dypiusLogo.svg"} alt="" width={160} height={90} />
                </Link>
                <div className="col-2 text-white d-flex flex-column gap-3">
                  <h4 className="fw-normal">About Us</h4>
                  {about.map((item, index) => (
                    <Link
                      key={index}
                      to={item.link}
                      className="text-white text-decoration-none footer-type-link"
                    >
                      <h5>{item.title}</h5>
                    </Link>
                  ))}
                </div>
                <div className="col-2 text-white d-flex flex-column gap-3">
                  <h4 className="fw-normal">Solutions</h4>

                  {products.slice(0, 2).map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      target="_blank"
                      className="text-white text-decoration-none footer-type-link"
                    >
                      <h5>{item.title}</h5>
                    </a>
                  ))}

                  {products.slice(2, 3).map((item, index) => (
                    <Link
                      key={index}
                      to={item.link}
                      className="text-white text-decoration-none footer-type-link"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <h5>{item.title}</h5>
                    </Link>
                  ))}
                  {products.slice(3, 4).map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      target="_blank"
                      className="text-white text-decoration-none footer-type-link"
                    >
                      <h5>{item.title}</h5>
                    </a>
                  ))}

                  {products.slice(4, 6).map((item, index) => (
                    <Link
                      key={index}
                      to={item.link}
                      className="text-white text-decoration-none footer-type-link"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <h5>{item.title}</h5>
                    </Link>
                  ))}
                  {products.slice(6, 7).map((item, index) => (
                    <a
                      className="text-white text-decoration-none footer-type-link"
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <h5>{item.title}</h5>
                    </a>
                  ))}
                </div>
             
                <div className="col-2 text-white d-flex flex-column gap-3">
                  <h4 className="fw-normal">Announcements</h4>
                  <div className="d-flex flex-column gap-3">
                    {announcements.map((item, index) => (
                      <Link
                        key={index}
                        to={item.link}
                        className="text-white text-decoration-none footer-type-link"
                        state={{ newsType: item.props }}
                      >
                        <h5>{item.title}</h5>
                      </Link>
                    ))}
                  </div>
                  <div
                    className="d-flex flex-column gap-3 position-relative"
                    style={{ bottom: "-60px" }}
                  >
                    <Link
                      to={"/terms-of-service"}
                      className="text-white text-decoration-none footer-type-link"
                    >
                      <h5>Terms of Service</h5>
                    </Link>
                  
                  </div>
                </div>
              </>
            )}
    
          </div>
          <hr className="d-none d-lg-block" />

          <div className="row w-100 justify-content-center align-items-center py-3 m-0">
            <p
              className="mb-0 text-white fw-light"
              style={{ fontSize: "12px" }}
            >
              Copyright © Dypius {year.getFullYear()}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
      <OutsideClickHandler onOutsideClick={() => setMetaverse(false)}>
        <div
          className={`metaverse-modal-wrapper ${
            metaverse && "metaverse-active"
          } flex-column p-5 d-flex gap-3 align-items-center justify-content-center`}
        >
          <img
            src={"https://cdn.worldofdypians.com/dypius/xMark.svg"}
            alt=""
            className="x-mark"
            onClick={() => setMetaverse(false)}
          />
          <img src={"https://cdn.worldofdypians.com/dypius/metaverseModal.svg"} alt="" />
          <img src={"https://cdn.worldofdypians.com/dypius/comingSoon.png"} alt="" width={400} />
          <Title
            top="Stay"
            bottom="tuned"
            align="d-flex flex-row align-items-center gap-2"
          />
        </div>
      </OutsideClickHandler>
    </>
  );
};

export default Footer;
